/** Hook to control the video and audio tracks of the local and shared streams */

import type { BusName } from '@tunasong/models'
import { useEffect, useState } from 'react'
import { MediaStreamRecorder } from '../recorder/media-recorder.js'
import type { Recorder } from '../recorder/recorder.js'
import { WavRecorder } from '../recorder/wav-recorder.js'
import { useMixer } from './mixer.hook.js'

export const useRecorder = (type: 'wav' | 'stream' = 'stream', busName: BusName = 'record') => {
  const [recorder, setRecorder] = useState<Recorder | undefined>(undefined)
  const mixer = useMixer()

  /** Create a recorder when busName, mixer or type changes */
  useEffect(() => {
    if (!mixer) {
      return
    }
    const stream = mixer.getStream(busName)?.stream
    const r = type === 'stream' && stream ? new MediaStreamRecorder(stream, { type: 'audio' }) : new WavRecorder(mixer)

    setRecorder(r)

    return () => {
      r.destroy()
      setRecorder(undefined)
    }
  }, [busName, mixer, type])

  return recorder
}
